"use client"

import Script from "next/script"

export function BugHerd() {
  const apiKey = process.env.NEXT_PUBLIC_BUGHERD_API_KEY
  const bugherdEnabled = process.env.NEXT_PUBLIC_BUGHERD_ENABLED

  if (!apiKey || bugherdEnabled !== "true") return null

  return (
    <Script
      src={`https://www.bugherd.com/sidebarv2.js?apikey=${apiKey}`}
      strategy="lazyOnload"
    />
  )
}
